import axios from 'axios'

export default () => {
  return axios.create({
    baseURL : process.env.VUE_APP_API_ENDPOINT,
    timeout : process.env.VUE_APP_TIMEOUT,
    headers : {'Content-Type' : 'application/json'}
  })
}
